<template>
  <div class="shouye-center-a">
    <div class="center">
        <h1>大玩家，室内新游乐典范</h1>
        <p>
            致力于通过对线下娱乐场景的精细化运营与创新，为积极乐观、热爱生活的消费者提供极致的快乐体验。 <br/>大玩家在传统电玩的基础上，创造性的融合了室内嘉年华、电子竞技、棒球、射箭、保龄球等运动休闲项目，以及具有领先科技元素的炫酷影吧、VR体验馆等，引领了中国室内新游乐时代。
        </p>
        <div class="sy-a-cen">
            <dl>
                <dt><img src="@s/skin/web/img/index/mendian.png"/></dt>
                <dd>
                    <span>超</span><a id="one" href="">0</a><span>家</span></dd>
                <p>门店</p>
                <h4>stores</h4>
            </dl>
            <dl>
                <dt><img src="@s/skin/web/img/index/chengshi.png"/></dt>
                <dd>
                    <span>超</span><a id="two" href="">12</a><span>个</span></dd>
                <p>城市</p>
                <h4>cities</h4>
            </dl>
            <dl>
                <dt><img src="@s/skin/web/img/index/yonghu.png"/></dt>
                <dd>
                    <span>超</span><a id="three" href="">24</a><span>万</span></dd>
                <p>会员</p>
                <h4>members</h4>
            </dl>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "A",
  data() {
    return {
    };
  },
  mounted(){
      var a = 400,
        b = 200,
        c = 1200;

        fn()

        var one = document.getElementById('one')
        var two = document.getElementById('two')
        var three = document.getElementById('three')
        var scrool1500 = false;
        $(window).scroll(function() {
            fn();
        });
        function fn() {
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if(scrollTop > 500 && scrollTop < 700) {
                if(!scrool1500) {
                    var timer = setInterval(function() {
                        if(Number(one.innerHTML) >= a) {
                            clearInterval(timer)
                        } else {
                            one.innerHTML = Number(one.innerHTML) + 1;
                        }
                    }, 4 / a * 1000)
                    var timer2 = setInterval(function() {
                        if(Number(two.innerHTML) >= b) {
                            clearInterval(timer2)
                        } else {
                            two.innerHTML = Number(two.innerHTML) + 1;
                        }
                    }, 4 / b * 1000)
                    var timer3 = setInterval(function() {
                        if(Number(three.innerHTML) >= c) {
                            clearInterval(timer3)
                        } else {
                            three.innerHTML = Number(three.innerHTML) + 1;

                        }
                    }, 4 / c * 1000)

                } else {
                    return false;
                }
            } else if(scrollTop < 1200) {
                scrool1500 = false;
            }

        }
  }
}
</script>
